import { Switch as AntSwitch } from 'antd';
import { SwitchProps } from 'antd';
import styled from 'src/theme';

export const Switch = styled((props: SwitchProps) => <AntSwitch {...props} />)`
  background-color: ${props => props.theme.colors.orange} !important;
  color: white !important;
  .ant-click-animating-node {
    display: none;
  }
`;
